editConfirmButtonController.$inject = [
                                         '$scope', 
                                         '$mdDialog', 
                                         '$translate',
                                         'QuickRepliesFactory',
                                         'elementData',
                                         'elementView'];
export function editConfirmButtonController($scope,
                                            $mdDialog,
                                            $translate,
                                            QuickRepliesFactory,
                                            elementData,
                                            elementView) {
  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.initTypeDropdownItems = initTypeDropdownItems;
  $scope.onTypeChange = onTypeChange;
  $scope.isButtonUrlValid = isButtonUrlValid;

  init();

  function init() {
    $scope.elementData = elementData;
    $scope.elementView = elementView;

    initTypeDropdownItems()
  }

  function ok() {
    $mdDialog.hide({ type: 'ok', data: $scope.elementData });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function initTypeDropdownItems() {
    $scope.typeDropdownItems = [{
        id: 'postback', 
        label: $translate.instant('parameters/quick_replies/details/graph/line_confirm_box/edit_button_type_postback')
      },{
        id: 'url', 
        label: $translate.instant('parameters/quick_replies/details/graph/line_confirm_box/edit_button_type_url')
    }];
  }

  function onTypeChange() {
    elementData.url = null;
  }

  function isButtonUrlValid() {
    if (elementData.type == 'url') {
      return QuickRepliesFactory.isLineUrlValid(elementData.url)
    } else {
      return true;
    }
  }

}
